import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { filled, empty, half } from './paths.js';
import { TripadvisorRating as TripadvisorRating$2, RatingContainer, RatingImageWrapper, Grade, Label } from './TripadvisorRating.style.js';
import texts from './TripadvisorRating.texts.js';
import Owl from './Owl.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';

var _excluded = ["rating", "onClick", "iconGrading", "showScale", "showLabel", "hideLogo", "inlineLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TripadvisorRating = function TripadvisorRating(_ref) {
  var rating = _ref.rating,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$iconGrading = _ref.iconGrading,
    iconGrading = _ref$iconGrading === void 0 ? false : _ref$iconGrading,
    _ref$showScale = _ref.showScale,
    showScale = _ref$showScale === void 0 ? false : _ref$showScale,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel,
    _ref$hideLogo = _ref.hideLogo,
    hideLogo = _ref$hideLogo === void 0 ? false : _ref$hideLogo,
    _ref$inlineLabel = _ref.inlineLabel,
    inlineLabel = _ref$inlineLabel === void 0 ? false : _ref$inlineLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  if (typeof rating !== 'number' || rating < 1) {
    return false;
  }
  var displayRating = rating.toFixed(1).replace('.', ',');
  if (showScale) {
    displayRating += '/5';
  }
  var ratings = [];
  for (var i = 0; i < 5; i += 1) {
    var path = filled;
    if (rating <= i) {
      path = empty;
    }
    if (rating > i && rating < i + 1) {
      path = half;
    }
    ratings.push(/*#__PURE__*/jsx("svg", {
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      children: /*#__PURE__*/jsx("path", {
        d: path
      })
    }, i));
  }
  var potentialButtonProps = onClick ? {
    as: 'button',
    type: 'button'
  } : null;
  return /*#__PURE__*/jsxs(TripadvisorRating$2, _objectSpread(_objectSpread(_objectSpread({}, potentialButtonProps), rest), {}, {
    onClick: onClick,
    $hasOnclick: onClick,
    $inlineLabel: inlineLabel,
    title: "Tripadvisor",
    children: [/*#__PURE__*/jsxs(RatingContainer, {
      "aria-hidden": "true",
      children: [!hideLogo && /*#__PURE__*/jsx(Owl, {}), iconGrading && /*#__PURE__*/jsx(RatingImageWrapper, {
        children: ratings
      }), !iconGrading && /*#__PURE__*/jsx(Grade, {
        children: displayRating
      })]
    }), showLabel && /*#__PURE__*/jsx(Label, {
      "aria-hidden": "true",
      children: "Tripadvisor"
    }), /*#__PURE__*/jsx("span", {
      className: "visually-hidden",
      children: "".concat(texts[culture].tripadvisor, ": ").concat(rating, " of 5")
    })]
  }));
};
var TripadvisorRating$1 = TripadvisorRating;

export { TripadvisorRating$1 as default };
//# sourceMappingURL=TripadvisorRating.js.map
